"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");

var _index2 = require("../../../utils/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : ILLUSTRATION : STYLES --------------- ++++++++++ */


var _default = {
  illustration: {
    backgroundColor: 'transparent',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    display: 'block',
    '&.name-placeholder': {
      backgroundImage: "url(".concat(_index2.url.static.files.images, "/iui/graphic-placeholder.png)"),
      width: (0, _index.pxToEm)(125),
      height: (0, _index.pxToEm)(100)
    },
    '&.name-error-404': {
      backgroundImage: "url(".concat(_index2.url.static.files.images, "/iui/illustration-404.svg)"),
      width: (0, _index.pxToEm)(330),
      height: (0, _index.pxToEm)(283)
    },
    '&.name-error-500, &.name-error-403': {
      backgroundImage: "url(".concat(_index2.url.static.files.images, "/iui/illustration-500.svg)"),
      width: (0, _index.pxToEm)(235),
      height: (0, _index.pxToEm)(261)
    },
    '&.name-insight': {
      backgroundImage: "url(".concat(_index2.url.static.files.images, "/iui/illustration-notification-insight.svg)"),
      width: (0, _index.pxToEm)(200),
      height: (0, _index.pxToEm)(200)
    },
    '&.name-paintbrush': {
      backgroundImage: "url(".concat(_index2.url.static.files.images, "/iui/illustration-empty-embed.svg)"),
      width: (0, _index.pxToEm)(124),
      height: (0, _index.pxToEm)(198)
    },
    '&.name-embed': {
      backgroundImage: "url(".concat(_index2.url.static.files.images, "/iui/embed-layout-large-pic-active.png)"),
      width: (0, _index.pxToEm)(140),
      height: (0, _index.pxToEm)(140)
    },
    '&.name-email': {
      backgroundImage: "url(".concat(_index2.url.static.files.images, "/iui/illustration-email.svg)"),
      width: (0, _index.pxToEm)(131),
      height: (0, _index.pxToEm)(171)
    },
    '&.name-payment': {
      backgroundImage: "url(".concat(_index2.url.static.files.images, "/iui/illustration-payment.svg)"),
      width: (0, _index.pxToEm)(150),
      height: (0, _index.pxToEm)(153)
    },
    '&.name-mobile': {
      backgroundImage: "url(".concat(_index2.url.static.files.images, "/iui/graphic-placement-mobile-blank-large.png)"),
      height: (0, _index.pxToEm)(380),
      width: (0, _index.pxToEm)(210)
    },
    '&.name-desktop': {
      backgroundImage: "url(".concat(_index2.url.static.files.images, "/iui/graphic-placement-rail-large.png)"),
      width: (0, _index.pxToEm)(673),
      height: (0, _index.pxToEm)(443)
    },
    // insticator (icon only)
    '&.name-insticator-icon': {
      backgroundImage: "url(".concat(_index2.url.static.files.images, "/iui/logo-insticator-icon.svg)"),
      backgroundPosition: '50%',
      height: (0, _index.pxToEm)(130),
      width: (0, _index.pxToEm)(130)
    },
    '&.name-dragdrop': {
      backgroundImage: "url(".concat(_index2.url.static.files.images, "/iui/icon-drag-drop.svg)"),
      height: (0, _index.pxToEm)(24),
      width: (0, _index.pxToEm)(10)
    },
    // ----- PRODUCT SHOTS ----- //
    '&.name-product-commenting': {
      backgroundImage: "url(".concat(_index2.url.static.files.images, "/iui/graphic-product-commenting.png)"),
      height: (0, _index.pxToEm)(1362),
      width: (0, _index.pxToEm)(1546),
      fontSize: '50%'
    },
    '&.name-product-content-incontent-autoblog': {
      backgroundImage: "url(".concat(_index2.url.static.files.images, "/iui/graphic-product-content-incontent-autoblog.png)"),
      height: (0, _index.pxToEm)(2880),
      width: (0, _index.pxToEm)(4320),
      fontSize: '50%'
    },
    '&.name-product-content-incontent-highlight': {
      backgroundImage: "url(".concat(_index2.url.static.files.images, "/iui/graphic-product-content-incontent-highlight.png)"),
      height: (0, _index.pxToEm)(1004),
      width: (0, _index.pxToEm)(1788),
      fontSize: '50%'
    },
    '&.name-product-content-mobile-insite': {
      backgroundImage: "url(".concat(_index2.url.static.files.images, "/iui/graphic-product-content-mobile-insite.png)"),
      height: (0, _index.pxToEm)(1564),
      width: (0, _index.pxToEm)(2558),
      fontSize: '50%'
    },
    '&.name-product-content-nintendo': {
      backgroundImage: "url(".concat(_index2.url.static.files.images, "/iui/graphic-product-content-nintendo.png)"),
      height: (0, _index.pxToEm)(560),
      width: (0, _index.pxToEm)(677),
      fontSize: '50%'
    },
    '&.name-product-content-rail-mobile': {
      backgroundImage: "url(".concat(_index2.url.static.files.images, "/iui/graphic-product-content-rail-mobile.png)"),
      height: (0, _index.pxToEm)(1604),
      width: (0, _index.pxToEm)(2534),
      fontSize: '50%'
    },
    '&.name-product-content-incontent-animated': {
      backgroundImage: "url(".concat(_index2.url.static.files.images, "/iui/graphic-product-content-incontent-animated.gif)"),
      height: (0, _index.pxToEm)(894),
      width: (0, _index.pxToEm)(1000)
    },
    '&.name-product-content-mobile-animated': {
      backgroundImage: "url(".concat(_index2.url.static.files.images, "/iui/graphic-product-content-mobile-animated.gif)"),
      height: (0, _index.pxToEm)(543),
      width: (0, _index.pxToEm)(700)
    }
  }
};
exports.default = _default;